/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrganizationSalesUpdateSubscription
 */
export interface OrganizationSalesUpdateSubscription {
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesUpdateSubscription
     */
    org_code: string;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesUpdateSubscription
     */
    subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesUpdateSubscription
     */
    ops_subscription_count: number;
    /**
     * 
     * @type {number}
     * @memberof OrganizationSalesUpdateSubscription
     */
    respond_subscription_count: number;
    /**
     * 
     * @type {string}
     * @memberof OrganizationSalesUpdateSubscription
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrganizationSalesUpdateSubscription interface.
 */
export function instanceOfOrganizationSalesUpdateSubscription(value: object): value is OrganizationSalesUpdateSubscription {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('subscription_count' in value) || value['subscription_count'] === undefined) return false;
    if (!('ops_subscription_count' in value) || value['ops_subscription_count'] === undefined) return false;
    if (!('respond_subscription_count' in value) || value['respond_subscription_count'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrganizationSalesUpdateSubscriptionFromJSON(json: any): OrganizationSalesUpdateSubscription {
    return OrganizationSalesUpdateSubscriptionFromJSONTyped(json, false);
}

export function OrganizationSalesUpdateSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationSalesUpdateSubscription {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'subscription_count': json['subscription_count'],
        'ops_subscription_count': json['ops_subscription_count'],
        'respond_subscription_count': json['respond_subscription_count'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrganizationSalesUpdateSubscriptionToJSON(json: any): OrganizationSalesUpdateSubscription {
    return OrganizationSalesUpdateSubscriptionToJSONTyped(json, false);
}

export function OrganizationSalesUpdateSubscriptionToJSONTyped(value?: OrganizationSalesUpdateSubscription | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'subscription_count': value['subscription_count'],
        'ops_subscription_count': value['ops_subscription_count'],
        'respond_subscription_count': value['respond_subscription_count'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

